// extracted by mini-css-extract-plugin
export default {"fitToText":"RFsIJI","optionItemFitToText":"bDe6py","optionItemTextFitToText":"zNUBFa","optionItemText":"DC5h2Q","disabled":"KS1dKA","selected":"Fz8Gvk","hovered":"BbTvDl"};